/**
 * StrongFitLogo.jsx
 * Styled logo component with glow effect on black background
 */
import React from 'react';

const StrongFitLogo = ({ 
  size = 'md', 
  showGlow = true,
  className = '',
  src = '/assets/invictafit-logo.png',
  alt = 'Logo',
}) => {
  // Size variants
  const sizes = {
    xs: { container: 'w-8 h-8', logo: 'w-6 h-6' },
    sm: { container: 'w-10 h-10', logo: 'w-8 h-8' },
    md: { container: 'w-14 h-14', logo: 'w-10 h-10' },
    lg: { container: 'w-20 h-20', logo: 'w-16 h-16' },
    xl: { container: 'w-32 h-32', logo: 'w-24 h-24' },
    '2xl': { container: 'w-48 h-48', logo: 'w-40 h-40' }
  };

  const sizeConfig = sizes[size] || sizes.md;

  return (
    <div 
      className={`relative flex items-center justify-center rounded-xl ${sizeConfig.container} ${className}`}
      style={{ 
        backgroundColor: '#000000',
        boxShadow: showGlow 
          ? '0 0 20px rgba(201, 162, 39, 0.4), 0 0 40px rgba(201, 162, 39, 0.2), inset 0 0 15px rgba(201, 162, 39, 0.1)' 
          : 'none',
        border: '1px solid rgba(201, 162, 39, 0.3)'
      }}
    >
      {/* Subtle inner glow overlay */}
      {showGlow && (
        <div 
          className="absolute inset-0 rounded-xl"
          style={{
            background: 'radial-gradient(circle at center, rgba(201, 162, 39, 0.15) 0%, transparent 70%)'
          }}
        />
      )}
      
      {/* Logo */}
      <img 
        src={src} 
        alt={alt}
        className={`${sizeConfig.logo} object-contain relative z-10`}
        style={{
          filter: showGlow ? 'drop-shadow(0 0 8px rgba(201, 162, 39, 0.5))' : 'none'
        }}
      />
    </div>
  );
};

// Animated version for splash screen
export const StrongFitLogoAnimated = ({ size = 'xl' }) => {
  return (
    <div className="relative">
      {/* Pulsing glow background */}
      <div 
        className="absolute inset-0 rounded-xl animate-pulse"
        style={{
          background: 'radial-gradient(circle, rgba(201, 162, 39, 0.3) 0%, transparent 70%)',
          transform: 'scale(1.5)'
        }}
      />
      <StrongFitLogo size={size} showGlow={true} />
    </div>
  );
};

export default StrongFitLogo;
